/* Ebb revamp page set (2026-10-17): the FAQ search field filters the questions in place (ARMRA help-centre search), and the
   basic collection's filter and sort controls submit Shopify's own filter form. */
(() => {
  const initFaq = (faq) => {
    if (faq.dataset.hqReady) return;
    faq.dataset.hqReady = '1';
    const input = faq.querySelector('[data-hq-faq-search]');
    const items = [...faq.querySelectorAll('[data-hq-faq-item]')];
    const none = faq.querySelector('[data-hq-faq-none]');
    if (!input) return;
    input.addEventListener('input', () => {
      const raw = input.value.trim();
      const q = raw.toLowerCase();
      let shown = 0;
      items.forEach((item) => {
        const hit = !q || item.textContent.toLowerCase().includes(q);
        item.hidden = !hit;
        if (hit) shown += 1;
        item.open = hit && q.length >= 3;
      });
      if (none) {
        none.hidden = shown > 0;
        none.textContent = shown ? '' : (none.dataset.tpl || '').replace('%%', raw);
      }
    });
  };
  // Basic collection: a ticked filter or a new sort reloads the collection with Shopify's own filter parameters.
  const initFilters = (form) => {
    if (form.dataset.hqReady) return;
    form.dataset.hqReady = '1';
    // Empty price fields stay out of the URL, so a filtered link carries only the filters in use.
    const send = () => { form.querySelectorAll('input[type=number]').forEach((i) => { i.disabled = i.value === ''; }); form.submit(); };
    form.querySelectorAll('[data-hq-filter-input]').forEach((input) => input.addEventListener('change', send));
    form.addEventListener('submit', (e) => { e.preventDefault(); send(); });
    form.querySelectorAll('details.hq-fd').forEach((d) => d.addEventListener('toggle', () => {
      if (d.open) form.querySelectorAll('details.hq-fd[open]').forEach((o) => { if (o !== d) o.open = false; });
    }));
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) form.querySelectorAll('details.hq-fd[open]').forEach((o) => { o.open = false; }); });
  };
  const init = (root) => {
    root.querySelectorAll('[data-hq-faq]').forEach(initFaq);
    root.querySelectorAll('[data-hq-filters]').forEach(initFilters);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
